module.exports = __webpack_public_path__ + "static/media/transfer.36d0254e.svg";